import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './shell/App';
import './shell/base.css';
import { initializeLocale } from './shared/i18n';

const root = document.getElementById('root');
const path = window.location.pathname;
initializeLocale();

const titles: Array<[string, string]> = [
  ['/account', 'Безпека акаунта · SweetLana'],
  ['/login', 'Вхід · SweetLana'],
  ['/admin/monitoring', 'Моніторинг · SweetLana'],
  ['/admin/library', 'Медіатека · SweetLana'],
  ['/admin/segue', 'Переходи · SweetLana'],
  ['/admin', 'Розклад · SweetLana'],
  ['/studio', 'Ефірна студія · SweetLana'],
];
const matchedTitle = titles.find(([prefix]) => path === prefix || path.startsWith(`${prefix}/`));
if (matchedTitle !== undefined) document.title = matchedTitle[1];

if (path === '/dj' || path.startsWith('/dj/')) {
  document.querySelector<HTMLLinkElement>('link[rel="manifest"]')?.setAttribute('href', '/dj.webmanifest');
  document.querySelector<HTMLMetaElement>('meta[name="theme-color"]')?.setAttribute('content', '#0b0d0f');
  document.title = 'Мобільний пульт · SweetLana';
}

if (path === '/guest' || path.startsWith('/guest/')) {
  document.querySelector<HTMLMetaElement>('meta[name="theme-color"]')?.setAttribute('content', '#0b0d0f');
  document.title = 'Гостьова студія · SweetLana';
}

if (root === null) {
  throw new Error('Missing #root application mount');
}

createRoot(root).render(
  <StrictMode>
    <App path={path} />
  </StrictMode>,
);

if ((path === '/' || path === '/dj' || path.startsWith('/dj/')) && 'serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js', { scope: '/' });
  });
}
